import { channelApi } from 'app/services/api';

import { toInlineError } from '../marginCenter.actionUtils';

// LEN-804: the company's default pricing channel is read and saved by the Channels tab control that
// shows it, so these thunks return the outcome ({ data, error }) and keep nothing in the store — like
// the anomaly thresholds. A 404 (a channel that is no longer the company's) is shown inline.
export const readDefaultPricingChannelAction = () => async () => {
  try {
    const { data } = await channelApi.getDefaultPricingChannel();

    return { data: { channelId: data?.channelId ?? null }, error: null };
  } catch (error) {
    return { data: null, error: toInlineError(error) };
  }
};

export const saveDefaultPricingChannelAction = channelId => async () => {
  try {
    const { data } = await channelApi.updateDefaultPricingChannel(channelId ?? null);

    return { data: { channelId: data?.channelId ?? null }, error: null };
  } catch (error) {
    return { data: null, error: toInlineError(error) };
  }
};
